import React from "react";

const UserContext = React.createContext();
const ConfigContext = React.createContext();

export {UserContext,ConfigContext};